import {Injectable} from '@angular/core';
import {AmfAbstractService} from "../amf-abstract.service";
import {JSessionIdCookieService} from "../../storage/usuario/jsession-id-cookie.service";
import {ResponseAmf} from "../../model/shared/response-amf";
import { InterceptAmfService } from '../intercept/intercept-amf.service';

@Injectable({
    providedIn: 'root'
})
export class CodigoBarrasService extends AmfAbstractService {

    private static _API = 'CodigosBarrasService';

    constructor(private _jSessionIdCookieService: JSessionIdCookieService, private _interceptAmfService: InterceptAmfService) {
        super(CodigoBarrasService._API);
    }

    findByClienteAndCnpjAndProduto(clienteSg: number, cnpjClienteSg: string, codigoProduto: number): Promise<ResponseAmf> {
        return this._interceptAmfService.interceptAmf(this._amf, CodigoBarrasService._API, 'FindByClienteAndCnpjAndProduto', [clienteSg, cnpjClienteSg, codigoProduto], this._jSessionIdCookieService.get());
    }

}
